import React from 'react'

const Loading = () => {

  return (
    <section className="loading-wrapper">
      <h1>LOADING...</h1>
    </section>
    
  )

}

export default Loading;